// extracted by mini-css-extract-plugin
export default {"waffleNavContainer":"tqOhsHg_wR7BglW0tr_7","waffleNavMenu":"iGxucVpiVgXWPMuEi3zl","deprecatedNotarizeStyle":"p27gmEmVe68swBSZskDA","logoContainer":"UosJaPc_5Mh1lmNVwhXX"};